import React, { Fragment } from 'react';
import { ChevronRightIcon } from 'lucide-react';
import { Reveal } from './Reveal';
import { steps } from '../constants/data';
export function ProductPresentation() {
  return <section className="w-full px-5 py-16 sm:py-24" style={{
    background: 'linear-gradient(180deg, #0A0A0A 0%, #050B18 100%)'
  }} data-id="element-221">
      <div className="mx-auto max-w-5xl text-center" data-id="element-222">
        <Reveal data-id="element-223">
          <span className="inline-block glass px-4 py-2 text-xs sm:text-sm font-semibold" style={{
          color: '#00C853'
        }} data-id="element-224">
            🏆 Sistema N°1 de Educación Financiera para Jóvenes Argentinos
          </span>

          <h2 className="mt-6 text-3xl sm:text-4xl font-extrabold" data-id="element-225">
            💸 MEGAPACK: FINANZAS PARA JÓVENES™
          </h2>

          <p className="mt-3 text-lg sm:text-xl font-semibold" style={{
          color: '#00C853'
        }} data-id="element-226">
            6 Tomos + 3 Bonos + Ebook Premium IA
          </p>

          <p className="mt-4 text-base sm:text-lg text-white/70" data-id="element-227">
            El camino es claro:
          </p>
        </Reveal>

        <div className="mt-10 flex flex-col sm:flex-row sm:flex-wrap items-center justify-center gap-3" data-id="element-228">
          {steps.map((step, i) => <Fragment key={step.label} data-id="element-229">
              <Reveal delay={i * 0.08} className="w-full sm:w-auto" data-id="element-230">
                <span className="block w-full sm:w-auto rounded-full px-5 py-2.5 text-sm font-semibold border" style={{
              color: step.color,
              borderColor: `${step.color}55`,
              backgroundColor: `${step.color}14`
            }} data-id="element-231">
                  {step.label}
                </span>
              </Reveal>
              {i < steps.length - 1 && <ChevronRightIcon className="hidden sm:block w-5 h-5 text-white/30 rotate-0" aria-hidden="true" data-id="element-232" />}
            </Fragment>)}
        </div>
      </div>
    </section>;
}